// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1W_pr","type":"styles_type__1niqF","choices":"styles_choices__Dk2yI"};